import { css } from "@obby/components";

export const styles = {
  bigPopup: css({
    position: "fixed",
    top: "0",
    left: "0",
    width: "100vw",
    height: "100vh",
    overflow: "scroll",
    padding: "0",
    background: "white",
    zIndex: "$popup",
    transition: "all 700ms",
    top: "0",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",

    variants: {
      shouldHidden: {
        true: {
          top: "100% !important"
        }
      }
    }
  }),
  controls: css({
    position: "fixed",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    zIndex: "1",
    backgroundColor: "#fff"
  }),
  body: css({
    position: "relative",
    width: "100%"
  }),
  closeButton: css({
    position: "fixed",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "38px",
    width: "38px",
    left: "20px",
    top: "20px",
    cursor: "pointer",
    textAlign: "right",
    fontSize: "28px",
    fontWeight: "400",
    transition: "all 700ms",
    backgroundColor: "$camelot",
    borderRadius: "50px",

    g: {
      stroke: "$gallery"
    },

    variants: {
      shouldHidden: {
        true: {
          display: "none !important"
        }
      }
    }
  }),
  container: css({
    display: "flex",
    justifyContent: "center",
    minWidth: "350px",
    padding: "0 20px",
    overflowY: "auto",
    width: "100%"
  })
};
